import React from "react";
import { getStoredData } from '../../JsonFiles/fetchData';
import "./ContactPage.css";
import ContactOfficeDetails from '../../components/ContactOfficeDetails/ContactOfficeDetails';
import ContactUsForm from '../../components/ContactUsForm/ContactUsForm';
import IntroTemplate from "../../components/IntroTemplate/IntroTemplate";

const ContactPage = () => {


  const data = getStoredData()?.["8"] ?? {};

  return (
    <div className="contact-background">
      <IntroTemplate logo={data.logo} title={data.title} image={data.image} />
      <ContactOfficeDetails data={data.ContactMap}/>
     <ContactUsForm data={data.ContactContent}/>
    </div>
  );
};

export default ContactPage;
